// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuPage_container__3j3ju","iframe":"MenuPage_iframe__3N43K"};